import React, { useEffect, useState }  from 'react';
//import './styles/App.css';
import { Authenticator, ThemeProvider, defaultDarkModeOverride } from '@aws-amplify/ui-react';
import { BrowserRouter as Router } from 'react-router-dom';
import { Spinner } from "@cloudscape-design/components";
import '@aws-amplify/ui-react/styles.css';
import "@cloudscape-design/global-styles/index.css";

import { formFields } from './helpers/authFormFields'
import { configureAmplify } from './helpers/amplifyConfig';
import MainLayout from './components/MainLayout';
import { theme } from './styles/theme';
import PageRoutes from './pages/PageRoutes';

// Configure Amplify on app initialization
configureAmplify();

function AppContent({ signOut, user }) {
	const [userAttributes, setUserAttributes] = useState(null);
	const [jwtToken, setJwtToken] = useState('');
	useEffect(() => {
		const fetchJwtToken = async () => {
		try {
			if (user?.signInUserSession?.idToken?.jwtToken) {
				setJwtToken(user.signInUserSession.idToken.jwtToken.toString());
			}
			const attributes =  user.attributes
			setUserAttributes(attributes);

		} catch (error) {
			console.error("Error fetching session:", error);
		}
		};

		fetchJwtToken();
	}, [user]);

	if (!userAttributes) {
		return (
			<div style={{ 
				display: 'flex', 
				justifyContent: 'center', 
				alignItems: 'center', 
				height: '100vh',
				animation: 'pulse 1s infinite'
			}}>
				<Spinner size="large" style={{
				transform: 'scale(2)',
				filter: 'drop-shadow(0 0 10px #0972d3)'
				}}/>
			</div>
		);	
	}
  
	return (
		<Router>
			<MainLayout signOut={signOut} user={user}>
				<PageRoutes user={user} jwtToken={jwtToken} />
			</MainLayout>
		</Router>
	);
  }
  
  function App() {
	
	return (
	  <div style={{
		justifyContent: 'center',
		alignItems: 'center',
		minHeight: '100vh',
		backgroundColor: '#f2f3f3',
	  }}>
		<ThemeProvider theme={theme}>
		  <Authenticator 
			signUpAttributes={['nickname']} 
			formFields={formFields}
			hideSignUp={true}
			components={{
			  Header: () => (
				<div style={{
				  marginBottom: '24px',
				  textAlign: 'center',
				  marginTop: '10vw'
				}}>
				  <h1 style={{
					fontSize: '24px',
					color: '#16191f',
					margin: 0,
					fontWeight: '500',
					position: 'relative',
					paddingBottom: '12px'
				  }}>
					MicroTransform Login
					<div style={{
					  position: 'absolute',
					  bottom: 0,
					  left: '50%',
					  transform: 'translateX(-50%)',
					  width: '40px',
					  height: '3px',
					  backgroundColor: '#047d95',
					  borderRadius: '2px'
					}}/>
				  </h1>
				</div>
			  ),
			  Footer: () => (
				<div style={{
				  textAlign: 'center',
				  marginTop: '16px',
				  color: '#687078',
				  fontSize: '13px'
				}}>
				  © 2025 Amazon.com, Inc. or its affiliates
				</div>
			  )
			}}
		  >
			{({ signOut, user }) => 
			  (<div style={{
				padding: '-20px',
			  }}>
				<AppContent signOut={signOut} user={user} />
			  </div>)
			}
		  </Authenticator>
		</ThemeProvider>
	  </div>
	);
  }
  
  

export default App;

